import Vue, { VueConstructor } from 'vue';

export type VueClass<T> = VueConstructor<T & Vue>;

export default function constructMixins<A> (mixin1: VueClass<A>): VueClass<A>;
export default function constructMixins<A, B> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
): VueClass<A & B>;
export default function constructMixins<A, B, C> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
): VueClass<A & B & C>;
export default function constructMixins<A, B, C, D> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
  mixin4: VueClass<D>,
): VueClass<A & B & C & D>;
export default function constructMixins<A, B, C, D, E> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
  mixin4: VueClass<D>,
  mixin5: VueClass<E>,
): VueClass<A & B & C & D & E>;
export default function constructMixins<A, B, C, D, E, F> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
  mixin4: VueClass<D>,
  mixin5: VueClass<E>,
  mixin6: VueClass<F>,
): VueClass<A & B & C & D & E & F>;
export default function constructMixins<A, B, C, D, E, F, G> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
  mixin4: VueClass<D>,
  mixin5: VueClass<E>,
  mixin6: VueClass<F>,
  mixin7: VueClass<G>,
): VueClass<A & B & C & D & E & F & G>;
export default function constructMixins <A, B, C, D, E, F, G, H> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
  mixin4: VueClass<D>,
  mixin5: VueClass<E>,
  mixin6: VueClass<F>,
  mixin7: VueClass<G>,
  mixin8: VueClass<H>,
): VueClass<A & B & C & D & E & F & G & H>;
export default function constructMixins<A, B, C, D, E, F, G, H, I> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
  mixin4: VueClass<D>,
  mixin5: VueClass<E>,
  mixin6: VueClass<F>,
  mixin7: VueClass<G>,
  mixin8: VueClass<H>,
  mixin9: VueClass<I>,
): VueClass<A & B & C & D & E & F & G & H & I>;
export default function constructMixins<A, B, C, D, E, F, G, H, I, J> (
  mixin1: VueClass<A>,
  mixin2: VueClass<B>,
  mixin3: VueClass<C>,
  mixin4: VueClass<D>,
  mixin5: VueClass<E>,
  mixin6: VueClass<F>,
  mixin7: VueClass<G>,
  mixin8: VueClass<H>,
  mixin9: VueClass<I>,
  mixin10: VueClass<J>,
): VueClass<A & B & C & D & E & F & G & H & I & J>;
export default function constructMixins (...mixins: VueConstructor[]): VueConstructor {
  return Vue.extend({ mixins });
}
